<template lang="html">
    <div class="add-ccck">
        <my-title theTitle="申请财产查控"/>
            <van-cell-group class="fd-com-scroll">
                <van-field
                        class="item-right"
                        v-model="formData.cSqr"
                        required
                        clearable
                        readonly
                        label="申请人"
                ></van-field>
                <van-field
                        required
                        clearable
                        readonly
                        label="申请原因"
                ></van-field>
                <van-field 
                    class="evaluate-content"
                    v-model="formData.cSqckyy"
                    :autosize="fieldSize" 
                    type="textarea"
                    placeholder="请输入申请原因"></van-field>
                <div class="create-download">
                    <van-field
                            required
                            label="财产查控申请书"
                    ></van-field>
                </div>
                <div class="upload-box">
                    <van-uploader
                            :before-read="beforeRead"
                            :after-read="uploadFile"
                            :before-delete="deleteCl"
                            v-model="sqsclList"
                            :max-count="5"
                    ></van-uploader>
                    <br/>
                </div>
                <div style="padding: 0 10px 10px;;color: #999;">
                    {{mbxzts}}
                </div>
            </van-cell-group>
            <div class="fd-com-btn-container">
                <van-button
                    type="info"
                    round
                    plain
                    @click="handlerCancel()"
                    :disabled="!saveBtnClickable"
                >
                    取消
                </van-button>

                <van-button
                    type="info"
                    round
                    :disabled="!saveBtnClickable"
                    @click="addCcckAndReturn"
                >
                    确认
                </van-button>
            </div>

        <div class="uploading-wrap" v-show="isUpload">
            <div class="upload-text">
                <van-loading class="icon-upload"  type="spinner" />
                <span>上传中...</span>
            </div>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../../components/common/myTitle';
    import validate from '../../../utils/validator/validator';
    import {Dialog, Notify} from 'vant'
    import {
        sizeRule,
        cSqckyyRule,
        sqccckRule
    } from '../../../utils/validator/rules';
    import {mbxzts} from '../../../utils/consts';

    export default {
        data() {
            return {
                formData: {
                    cSqr: '',
                    cSqckyy: '',
                },
                postData: {
                    cBqId: '',
                    cSqclid: '',
                    cSqckyy: '',
                },
                sqsclList: [],
                mbxzts: mbxzts,
                fieldSize: {
                    maxHeight: 80,
                    minHeight: 80
                },
                isUpload:false,
                saveBtnClickable: true, // 保存按钮是否可以点击,
            }
        },
        components: {
            MyTitle,
        },
        created() {
            this.initCcckInfo();
            this.initBqSqrs();
        },
        methods: {
            handlerCancel(){
                Dialog.confirm({
                    title: '提示',
                    message: '确认取消吗?',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$router.go(-1)
                })
            },
            addCcckAndReturn() {
                this.formData.cSqckyy = this.formData.cSqckyy.replace(/\s+/g,"");
                this.postData.cSqckyy = this.formData.cSqckyy.replace(/\s+/g,"");
                let clids = "";
                // 校验上传材料信息是否完整
                const validatedClxx = this.validateClxx();
                validatedClxx.then(() => {
                    // 校验申请原因是否填写
                    const validateSqyy = this.validateSqyy();
                    validateSqyy.then(() => {
                        this.sqsclList.forEach((item) => {
                            clids = clids.concat(item.cSqclid, ",");
                        })
                        this.postData.cSqclid = clids.substring(0, clids.length - 1);
                        this.$axios.post('ssbq/api/sccls/bqjbxx/ckyy', this.postData)
                            .then(res => {
                                if (res.code == 200  || res.code == 204) {
                                    history.go(-1);
                                    this.$notify({'type': 'success', 'message': '操作成功'});
                                } else {
                                    this.$notify(res.message);
                                }
                            }).catch(() => {
                        });
                    })
                })
            },
            // 上传材料状态控制
            uploadStatus(status = null, message = null, id = null){
                let length = this.sqsclList.length
                this.sqsclList[length-1].cSqclid = id
                this.sqsclList[length-1].status = status
                this.sqsclList[length-1].message = message
            },
            // 上传财产查控申请书
            async uploadFile(file) {
                this.isUpload = true;
                this.saveBtnClickable = false;
                let i = 0
                let clid = await this.myId(i)
                let fd = new FormData();
                let f = file.file;
                fd.append("bqid", this.postData.cBqId);
                fd.append("cllx", 7);
                fd.append("files", f);
                fd.append("clid", clid);
                // this.uploadStatus('uploading', '上传中...')
                this.$axios.post('ssbq/api/sccls/dbxx/fileupload', fd)
                    .then(res => {
                        this.isUpload = false;
                        if (res.code == 200) {
                            // this.uploadStatus()
                            this.$notify({'type': 'success', 'message': '材料上传成功'});
                            this.saveBtnClickable = true;
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                    this.saveBtnClickable = true;
                    // this.uploadStatus('failed', '上传失败', clid)
                });
            },
            // 上传验证
            beforeRead(file) {
                if(file.size == 0){
                    Notify('上传文件必须大于0kb!')
                }
                let hFileType = "image/jpeg||image/jpg||image/bmp||image/gif||image/png"
                let imgFormat = "jpg、png、jpeg、bmp、gif"
                if (hFileType.indexOf(file.type) === -1) {
                    Notify({
                        message:`仅支持格式为${imgFormat}的图片!`,
                        type: 'danger',
                        duration: 5 * 1000
                    })
                    return false;
                }else if(file.size > (20 * 1024 * 1024)){
                    Notify('上传文件大小不能超过 20MB!')
                    return false;
                }
                return true;
            },
            // 删除材料
            deleteCl: function (name) {
                if(this.isUpload != true){
                   this.$axios.delete('ssbq/api/sccls/sccls/delsccl?id=' + name.cSqclid +"&bqid=" + this.postData.cBqId)
                    .then(res => {
                            if (res.code == 200) {
                                this.sqsclList.forEach((value, index)=>{
                                    if(value.cSqclid === name.cSqclid){
                                        this.sqsclList.splice(index,1)
                                    }
                                })
                                this.$notify({'type': 'success', 'message': '材料删除成功'});
                            } else {
                                this.$notify(res.message);
                            }
                        }).catch(() => {
                    });
               }else{
                     this.$notify("上传过程中不能删除！");
               }
            },
            initCcckInfo() {
                let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                this.postData.cBqId = currentBqid;
                this.$axios.get("ssbq/api/sccls/sccl/cllx?bqid=" + this.postData.cBqId + "&cllx=" + 7)
                    .then(res => {
                        if (res.code == 200) {
                            this.sqsclList.splice(0, this.sqsclList.length);
                            if (res.data.length > 0) {
                                this.formData.cSqckyy = res.data[0].cSqckyy;
                                this.sqsclList = res.data;
                            }
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                    this.$notify("系统异常");
                });
            },
            initBqSqrs() {
                this.$axios.get("ssbq/api/sqrs?bqid=" + this.postData.cBqId)
                    .then(res => {
                        if (res.code == 200) {
                            let sqrs = "";
                            let sqrIds = "";
                            res.data.forEach((item) => {
                                let sqr = {}
                                sqr.cId = item.cId
                                if (item.cSqrlx == "1") {
                                    sqr.sqrmc = item.cSqrxm
                                } else {
                                    sqr.sqrmc = item.cQymc
                                }
                                sqrs = sqrs.concat(sqr.sqrmc, "、");
                                sqrIds = sqrIds.concat(sqr.cId, ",");
                            });
                            this.formData.cSqr = sqrs.substring(0, sqrs.length - 1);
                            this.postData.cSqr = sqrIds.substring(0, sqrIds.length - 1);
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                    this.$notify("系统异常");
                });
            },
            downloadTemplate() {
                window.open("wsbq/ssbq/api/wjgl/tempdownload/" + 8);
            },
            validateClxx: function () {
                let descriptor = {
                    sqsclList:sqccckRule, // 申请书材料 必填
                };
                const validated = validate(descriptor, {
                    sqsclList: this.sqsclList // 申请书材料 必填
                });
                return validated
            },
            validateSqyy: function () {
                let descriptor = {
                    cSqckyy: new cSqckyyRule(true), // 原因
                };
                const validated = validate(descriptor, {
                    cSqckyy: this.formData.cSqckyy, // 申请原因
                });
                return validated
            },
            validateClSize: function (size) {
                let descriptor = {
                    clsize: new sizeRule(true), // 材料大小
                };
                const validated = validate(descriptor, {
                    clsize: size, // 材料大小
                });
                return validated
            },
            myId(i) {
                return new Promise((resolve, reject)=>{
                    i++
                    if (i > 3) {
                        this.$message({
                            type: 'error',
                            message: '系统错误，请重试!'
                        });
                    }
                    else {
                        this.$axios.get('ssbq/api/id').then((res) => {
                            resolve(res.data)
                        }).catch(() => {
                            this.myId(i)
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .add-ccck {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .uploading-wrap {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -60px;
        margin-left: -60px;
        z-index: 99;
        display:flex;
        justify-content:center;
        align-items:center;
    }

    .upload-text{
        .icon-upload{
            text-align:center;
        }
        >span{
            font-size:20px;
            color:#fff;
        }
    }

    .upload-box{
        width:90%;
        margin-left:5%;
        // margin-left:18px;
    }

    .evaluate-content {
        height: auto;
        /deep/textarea{
            text-align: left;
        }
    }

    /deep/.van-icon-delete:before {
        content: "\F031";
    }

    /deep/.van-uploader__preview-delete {
        position: absolute;
        height: 10%;
        top: -8px;
        right: -8px;
        color: #969799;
        font-size: 18px;
        background-color: #fff;
        border-radius: 100%;
    }
    /deep/[readonly]{
        color: #999 !important;
    }
</style>
